import * as React from 'react';

import { LinkButton } from '@cian/ui-kit';
import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './MapEntry.css';
import { trackMapUrlClick } from '../../containers/ListingsLinks/tracking';

interface IMapEntryProps {
  mapUrl: string;
}

export const MapEntry: React.FC<IMapEntryProps> = ({ mapUrl }) => {
  return (
    <div className={styles['container']}>
      <a
        className={styles['link-area']}
        href={mapUrl}
        onClick={trackMapUrlClick}
        target="_blank"
        rel="noreferrer"
        data-testid="MapEntry"
      />
      <LinkButton theme="fill_white_primary" size="M" beforeIcon={<IconActionMap16 color="icon-main-default" />}>
        Скидки на карте
      </LinkButton>
    </div>
  );
};
